__turbopack_context__.v({
  "body": "CDefault-module__Edfs3W__body",
  "header": "CDefault-module__Edfs3W__header",
  "root": "CDefault-module__Edfs3W__root",
  "subtitle": "CDefault-module__Edfs3W__subtitle",
  "title": "CDefault-module__Edfs3W__title",
});
